import LOOKUP_TYPES, {
  SUCCESS_PLAN_SIDE_BAR_ACTIONS,
} from '../../common/constants/SuccessPlanConstants';
import responseFormatter from '../../common/util/ResponseFormatter';
import {
  fetchSuccessPlanStatusLookups,
  fetchSuccessPlanProgressLookups,
  fetchMilestoneStatusLookups,
  fetchSuccessPlans,
  fetchSuccessPlanById,
  createSuccessPlan,
  editSuccessPlan,
  resetSuccessPlans,
  completeSuccessPlan,
  fetchSuccessPlanStatus,
  markSuccessPlanInprogress,
  cancelSuccessPlanComplete,
  archiveSuccessPlan,
  duplicateSuccessPlan,
} from '../routines/successPlanRoutines';

const { SUCCESS_PLAN_STATUS, MILESTONE_STATUS, SUCCESS_PLAN_PROGRESS } =
  LOOKUP_TYPES;
const initialState = {
  [SUCCESS_PLAN_STATUS]: {
    data: [],
    dataMap: {},
    loading: false,
    error: null,
  },
  [MILESTONE_STATUS]: {
    data: [],
    dataMap: {},
    loading: false,
    error: null,
  },
  [SUCCESS_PLAN_PROGRESS]: {
    data: [],
    dataMap: {},
    loading: false,
    error: null,
  },
  level: null,
  entityId: null,
  successPlanList: {
    data: [],
    loading: false,
    error: null,
  },
  successPlan: {
    data: null,
    loading: false,
    error: null,
  },
  successPlanStatus: {
    data: null,
    loading: false,
    error: null,
    showModal: false,
    action: SUCCESS_PLAN_SIDE_BAR_ACTIONS.EDIT,
  },
  actionLoading: false,
  duplicateSuccessPlan: {
    data: null,
    loading: false,
    error: null,
  },
};

const successPlanReducer = (state = initialState, action) => {
  switch (action.type) {
    case archiveSuccessPlan.TRIGGER: {
      return {
        ...state,
        actionLoading: true,
      };
    }
    case archiveSuccessPlan.FAILURE:
    case archiveSuccessPlan.SUCCESS: {
      return {
        ...state,
        actionLoading: false,
        successPlanStatus: { ...state.successPlanStatus, showModal: false },
      };
    }
    case completeSuccessPlan.SUCCESS:
    case markSuccessPlanInprogress.SUCCESS: {
      return {
        ...state,
        successPlanStatus: {
          ...state.successPlanStatus,
          data: null,
          loading: false,
          error: null,
          showModal: false,
        },
      };
    }

    case cancelSuccessPlanComplete.TRIGGER: {
      return {
        ...state,
        successPlanStatus: {
          ...state.successPlanStatus,
          data: null,
          loading: false,
          error: null,
          showModal: false,
        },
      };
    }
    case fetchSuccessPlanStatus.TRIGGER: {
      return {
        ...state,
        successPlanStatus: {
          ...state.successPlanStatus,
          data: null,
          loading: true,
          error: null,
          showModal: true,
          action: action.payload.action,
        },
      };
    }
    case fetchSuccessPlanStatus.SUCCESS: {
      return {
        ...state,
        successPlanStatus: {
          ...state.successPlanStatus,
          data: action.payload,
          loading: false,
        },
      };
    }
    case fetchSuccessPlanStatus.FAILURE: {
      return {
        ...state,
        successPlanStatus: {
          ...state.successPlanStatus,
          data: null,
          loading: false,
          error: action.payload.error,
          showModal: false,
        },
      };
    }
    case fetchSuccessPlans.TRIGGER:
      return {
        ...state,
        level: action.payload.level,
        entityId: action.payload.entityId,
        successPlanList: { ...state.successPlanList, loading: true },
      };
    case fetchSuccessPlans.SUCCESS:
      return {
        ...state,
        successPlanList: {
          ...state.successPlanList,
          data: action.payload,
          loading: false,
          error: null,
        },
      };
    case fetchSuccessPlans.FAILURE:
      return {
        ...state,
        successPlanList: {
          ...state.successPlanList,
          loading: false,
        },
      };
    case createSuccessPlan.TRIGGER:
    case editSuccessPlan.TRIGGER:
      return {
        ...state,
        actionLoading: true,
      };
    case createSuccessPlan.SUCCESS:
    case editSuccessPlan.SUCCESS:
      return {
        ...state,
        actionLoading: false,
      };
    case createSuccessPlan.FAILURE:
    case editSuccessPlan.FAILURE:
      return {
        ...state,
        actionLoading: false,
      };

    case fetchSuccessPlanById.TRIGGER:
      return {
        ...state,
        successPlan: { ...state.successPlan, data: null, loading: true },
      };
    case fetchSuccessPlanById.SUCCESS:
      return {
        ...state,
        successPlan: {
          ...state.successPlan,
          loading: false,
          data: action.payload,
        },
      };
    case fetchSuccessPlanById.FAILURE:
      return {
        ...state,
        successPlan: {
          ...state.successPlan,
          loading: false,
          error: action.payload.error,
        },
      };
    case duplicateSuccessPlan.TRIGGER:
      return {
        ...state,
        actionLoading: true,
        successPlanStatus: {
          ...state.successPlanStatus,
          data: null,
          loading: true,
          error: null,
          showModal: true,
          action: SUCCESS_PLAN_SIDE_BAR_ACTIONS.DUPLICATE,
          duplicateOnly: action.payload.duplicateOnly,
        },
      };
    case duplicateSuccessPlan.SUCCESS:
      return {
        ...state,
        actionLoading: false,
        successPlanStatus: {
          ...state.successPlanStatus,
          data: null,
          loading: false,
          error: null,
          showModal: false,
          duplicateOnly: false,
        },
      };
    case duplicateSuccessPlan.FAILURE:
      return {
        ...state,
        actionLoading: false,
        successPlanStatus: {
          ...state.successPlanStatus,
          loading: false,
          error: null,
          showModal: false,
          duplicateOnly: false,
        },
      };

    // LOOKUP STUFF BELOW

    case fetchSuccessPlanStatusLookups.TRIGGER: {
      return {
        ...state,
        [SUCCESS_PLAN_STATUS]: { ...state[SUCCESS_PLAN_STATUS], loading: true },
      };
    }
    case fetchSuccessPlanStatusLookups.FAILURE: {
      return {
        ...state,
        [SUCCESS_PLAN_STATUS]: {
          ...state[SUCCESS_PLAN_STATUS],
          error: action.payload.error,
          loading: false,
        },
      };
    }
    case fetchSuccessPlanStatusLookups.SUCCESS: {
      return {
        ...state,
        [SUCCESS_PLAN_STATUS]: {
          ...state[SUCCESS_PLAN_STATUS],
          data: action.payload,
          dataMap: responseFormatter(action.payload, 'lookupId'),
          loading: false,
          error: null,
        },
      };
    }

    case fetchSuccessPlanProgressLookups.TRIGGER: {
      return {
        ...state,
        [SUCCESS_PLAN_PROGRESS]: {
          ...state[SUCCESS_PLAN_PROGRESS],
          loading: true,
        },
      };
    }
    case fetchSuccessPlanProgressLookups.FAILURE: {
      return {
        ...state,
        [SUCCESS_PLAN_PROGRESS]: {
          ...state[SUCCESS_PLAN_PROGRESS],
          error: action.payload.error,
          loading: false,
        },
      };
    }
    case fetchSuccessPlanProgressLookups.SUCCESS: {
      return {
        ...state,
        [SUCCESS_PLAN_PROGRESS]: {
          ...state[SUCCESS_PLAN_PROGRESS],
          data: action.payload,
          dataMap: responseFormatter(action.payload, 'lookupId'),
          loading: false,
          error: null,
        },
      };
    }

    case fetchMilestoneStatusLookups.TRIGGER: {
      return {
        ...state,
        [MILESTONE_STATUS]: { ...state[MILESTONE_STATUS], loading: true },
      };
    }
    case fetchMilestoneStatusLookups.FAILURE: {
      return {
        ...state,
        [MILESTONE_STATUS]: {
          ...state[MILESTONE_STATUS],
          error: action.payload.error,
          loading: false,
        },
      };
    }
    case fetchMilestoneStatusLookups.SUCCESS: {
      return {
        ...state,
        [MILESTONE_STATUS]: {
          ...state[MILESTONE_STATUS],
          data: action.payload,
          dataMap: responseFormatter(action.payload, 'lookupId'),
          loading: false,
          error: null,
        },
      };
    }

    case resetSuccessPlans.TRIGGER: {
      return {
        ...state,
        successPlanList: {
          ...initialState.successPlanList,
          loading: true,
        },
        successPlan: {
          ...initialState.successPlan,
          loading: false,
        },
      };
    }

    default:
      return state;
  }
};

export default successPlanReducer;
